module.exports = __webpack_public_path__ + "img/brand-07.76430ebe.png";